import React, { useCallback } from 'react';
import { TSession, determineState, State } from './Sessions';
import { withRouter, RouteComponentProps } from 'react-router';
import { Tooltip, CircularProgress } from '@material-ui/core';
import { LinkDiv } from './SessionPrepareButton';
import { Error, CheckCircle } from '@material-ui/icons';
import { RunState } from '../../api';
import { CircularProgressWithLabel } from './SessionUploadButton';
import useSessionJobs, { isActive, toPercent } from './useSessionJobs';

interface Props extends RouteComponentProps {
  session: TSession;
}

const stateToText: { [state: string]: string } = {
  [RunState.CreateNamespace]: 'Creating namespace',
  [RunState.CreateTopics]: 'Creating Kafka topics',
  [RunState.Created]: 'The session is ready to be started',
  [RunState.DeleteNamespace]: 'Deleting namespace',
  [RunState.Deleted]: 'Deleted',
  [RunState.PostProcess]: 'Post processing',
  [RunState.StartDeployments]: 'Starting deployments',
  [RunState.StopDeployments]: 'Stopping deployments',
  [RunState.StopDeploymentsError]: 'Run failed, stopping deployments',
  [RunState.Stopped]: 'Run is finished',
  [RunState.Running]: 'Session is running',
  [RunState.CreateKafkaZookeeper]: 'Creating zookeeper and kafka',
  [RunState.Running]: 'Session is running',
};

const SessionRunButton: React.FunctionComponent<Props> = ({ session, history }) => {
  const state = determineState(session);
  const runJob = useSessionJobs(String(session.id)).find(
    (job) => job.type === 'pipeline-run' && job.runId === session.lastRun?.id && isActive(job)
  );

  const onClick = useCallback(
    (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (session.lastRun?.id) history.push('/runs/' + session.lastRun?.id);
    },
    [session, history]
  );

  if (state === State.Run || state === State.Label) {
    //In these state we can still edit the videos
    let child;
    if (session.lastRun?.state === RunState.Stopped) {
      if (session.lastRun?.errorMessage) {
        child = (
          <Tooltip title={session.lastRun?.errorMessage}>
            <Error color="error" />
          </Tooltip>
        );
      } else {
        child = (
          <Tooltip title={stateToText[session.lastRun.state]}>
            <CheckCircle color="secondary" />
          </Tooltip>
        );
      }
    } else {
      child = (
        <Tooltip title={session.lastRun?.state ? stateToText[session.lastRun.state] || session.lastRun.state : 'Unknown'}>
          <span>
            {runJob?.progress != null ? (
              <CircularProgressWithLabel color="secondary" value={toPercent(runJob)} />
            ) : (
              <CircularProgress color="secondary" size={24} />
            )}
          </span>
        </Tooltip>
      );
    }
    return (
      <LinkDiv onClick={onClick} disabled={!session.lastRun?.id}>
        {child}
      </LinkDiv>
    );
  }
  return <div />;
};

export default withRouter(SessionRunButton);
